import React, { Component } from "react";
import moment from "moment";
import { Spin } from "antd";
// 组件
import NoData from "@/components/common/no_data";
// 接口以及调用接口方法
import { successRateQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import Echarts from "echarts";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
// 图片
import legend1 from "@/assets/img/displayBoard/ds1.svg";
@connect((state) => state)
class SuccessRateBar extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置柱状图ID
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      noData: false, // 是否有数据
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      barData: [],
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      console.log("充电成功率一样");
    } else {
      console.log("充电成功率不一样");

      this.setState(
        {
          showSping: true,
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getSuccessRate();
        },
      );
    }
  }

  // 获取数据
  getSuccessRate() {
    // 获取成功率趋势数据
    fetchHandler(successRateQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      // console.log(res);
      if (res.data) {
        this.setState(
          {
            showSping: false,
            barData: [...res.data],
            noData: !res.data.length > 0,
          },
          () => {
            this.renderChart();
          },
        );
      }
    });
  }

  componentDidMount() {
    this.getSuccessRate();
  }

  renderChart() {
    window.removeEventListener("resize", () => {});
    const { barData } = this.state;
    // 假数据
    const xAxisData = [];
    const successData = [];
    const faulData = [];
    const allData = [];
    const successRateData = [];
    // const successListNoMap = [];

    // 获取数据
    barData.map((item) => {
      xAxisData.push(moment(item.date).format("MM.DD"));
      successData.push({
        value: item.successOrder,
        info: {
          totalOrder: item.totalOrder,
          successRate: item.successRate,
        },
      });
      // successListNoMap.push(item.successOrder);
      faulData.push(item.failureOrder);
      allData.push(item.totalOrder);
      successRateData.push(item.successRate);
      return true;
    });
    allData.sort((a, b) => Number(b) - Number(a));
    let maxVal = 0;
    if (allData.length > 0) {
      maxVal = Math.ceil(Number(allData[0]) / 10) * 10;
    }
    const myChart = Echarts.init(document.getElementById("successRateBar"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px">总订单：${params[1].data.info.totalOrder}，成功率：${params[1].data.info.successRate}%</div>`;
            str += `<div  style="padding:3px 24px 12px 10px">成功订单：${params[1].data.value}，失败订单：${params[0].data}</div>`;
            return str;
          }
        },
        // position: function (pos, params, dom, rect, size) {
        //   // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
        //   var obj = { top: 60 };
        //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        //   return obj;
        // }
      },
      color: ["#EB7F66", "#75DDB2"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "充电成功率",
            icon: `image://${legend1}`,
          },
          {
            name: "成功订单",
            // icon: "image://" + legend2,
          },
          {
            name: "失败订单",
            // icon: "image://" + legend3,
          },
        ],
        top: 0,
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "65px",
        right: "50px",
        bottom: "20px",
      },
      yAxis: [
        {
          type: "value",
          name: "（笔）",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: maxVal,
          interval: Math.ceil(maxVal / 10),
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
          },
        },
        {
          type: "value",
          name: "",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        {
          name: "失败订单",
          type: "bar",
          yAxisIndex: 0,
          stack: "1",
          data: faulData,
          barGap: "-100%",
        },
        {
          name: "成功订单",
          type: "bar",
          barWidth: 37,
          yAxisIndex: 0,
          stack: "1",
          barGap: "-100%",
          data: successData,
        },
        {
          name: "充电成功率",
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#76A5F7",
          },
          yAxisIndex: 1,
          // polarIndex: 2,
          data: successRateData,
        },
      ],
    };
    myChart.clear();
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      if (this.props.panelsInfo.activeKey === "0001") {
        myChart.resize();
      }
    });
  }

  render() {
    const content = (
      <Spin tip="加载中..." spinning={this.state.showSping}>
        <div className="exception-line-chart">
          <div className="line" id="successRateBar"></div>
        </div>
        {this.state.noData ? (
          <div className="no_data_com no_data_line">
            <NoData />
          </div>
        ) : null}
      </Spin>
    );

    return content;
  }
}

export default injectIntl(SuccessRateBar);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/successRateBar.js